<div class="flex-column">
    <ng-container *ngIf="this.loadingPatient && this.isPatientInputParam">
        <div class="flex-row align-center-center">
            <mat-spinner diameter="60"></mat-spinner>
        </div>
    </ng-container>
    <span *ngIf="!this.isPatientInputParam" class="headline-1 pls-4 mbs-5 text-primary-darker-title">
        {{ ('modules.admissions.patient-data.template-title' | exp:'':'Datos del paciente')  }}
    </span>
    <div [ngClass]="{ 'ml-1': !this.isPatientInputParam }" *ngIf="!this.loadingPatient">
        <app-theme-card themeScope="admissions" cardClass="mts-4 mx-1 data-management-container mat-elevation-z2 p-1">
            <div class="flex-column ml-4">
                <form [formGroup]="this.formPatient">
                    <div class="flex-column">
                        <div *ngIf="!this.isPatientInputParam" class="flex-row">
                            <span class="text-primary-darker-h3 flex-88 mbs-3">
                                {{ 'modules.admissions.patient-data.personal-data' | exp:'':'Datos personales' }}
                            </span>
                        </div>
                        <!--patient selector-->
                        <span *ngIf="!this.isPatientInputParam" class="subtitle-3 text-primary-darker mbs-1 ">
                            {{ 'modules.admissions.patient-data.patient-selector.title' | exp:'':'Crear o seleccionar un paciente' }}
                        </span>
                        <div *ngIf="!this.isPatientInputParam" class="flex-row flex-100">
                            <app-select-searching-dynamic-input
                                class="mbs-1"
                                [placeholder]="('modules.admissions.patient-data.patient-selector.placeholders.searching-patient' | exp:'':'Ingrese nombre y apellido o DNI')"
                                [name]="this.PATIENT_SEARCH"
                                [nameSearching]="this.PATIENT_SEARCHING"
                                [form]="this.admissionPatientForm"
                                class="flex-45" [httpGet]="this.loadPatientsByFullName"
                                (selectedWithEntity)="this.selected($event)"
                                 [calculateId]="this.calculateIdPatient"
                                [calculateName]="this.calculateNamePatient"
                                [defaultOptions]="[{id:'new',name:('modules.admissions.patient-data.patient-selector.placeholders.default-option' | exp:'':'Nuevo paciente')}]"
                                [placeholderNoValue]="('modules.admissions.patient-data.patient-selector.placeholders.no-value' | exp:'':'Sin resultados')"
                                [placeholderSearching]="('modules.admissions.patient-data.patient-selector.placeholders.searching-patient' | exp:'':'Ingrese nombre y apellido o DNI')"
                                [defaultValue]="'!!this.patientSelected ? this.calculateIdPatient(this.patientSelected)'">
                            </app-select-searching-dynamic-input>
                        </div>
                        <div class="flex-row flex-100 mt-1">
                            <div class="flex-column flex-2">
                                <span class="subtitle-3 text-primary-darker mbs-1" style="width: max-content;">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-document-type' | exp:'':'Tipo de documento' }}
                                </span>
                                <app-select-input [name]="this.PATIENT_TYPEDOCUMENT"
                                    [placeholder]="('modules.admissions.patient-data.patient-selector.placeholders.document-type' | exp:'':'Seleccionar')" [elements]="this.typeDocuments"
                                    [defaultValue]="'1'" [form]="this.formPatient">
                                </app-select-input>
                            </div>
                            <div class="flex-column flex-2 ml-1">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-document-number' | exp:'':'N° de documento' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_DOCUMENTNUMBER" [form]="this.formPatient"
                                    (changes)="this.validateDocumentNumber()">
                                </app-text-input>
                            </div>
                            <span class="text-secondary subtitle-5 mbs-3" *ngIf="!!this.closedCase">{{'modules.admissions.patient-data.patient-selector.nbsp' | exp:'':''}} {{this.closedCase?.patient?.surname}}, {{this.closedCase?.patient?.name}}
                                {{('modules.admissions.patient-data.patient-selector.cerrado-el' | exp:'':'cerrado el') | lowercase}} {{this.closedCaseDate}} <a href="{{routes.CASES + '/' + closedCase?.id}}"
                                    target="_blank" class="text-primary-darker">{{ 'modules.admissions.patient-data.patient-selector.open-case' | exp:'':'Ver caso' }}</a>
                            </span>
                            <div class="flex-column flex-2 ml-3">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-birth-date' | exp:'':'Fecha de nacimiento' }}
                                </span>
                                <app-date-picker [name]="this.PATIENT_BIRTHDATE" (onDateChange)="calculateAge()"
                                    [form]="this.formPatient">
                                </app-date-picker>
                            </div>
                            <div class="flex-column flex-2 ml-1 ">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-age' | exp:'':'Edad' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_AGE" [readonly]="true" [form]="this.formPatient">
                                </app-text-input>
                            </div>
                        </div>
                        <div class="flex-row flex-100">
                            <div class="flex-column flex-45">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-surname' | exp:'':'Apellido' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_SURNAME" [form]="this.formPatient">
                                </app-text-input>
                            </div>
                            <div class="flex-column flex-45 ml-5">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-name' | exp:'':'Nombre' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_NAME" [form]="this.formPatient">
                                </app-text-input>
                            </div>
                        </div>
                        <div class="flex-row flex-100">
                            <div class="flex-column flex-45">
                                <span class="subtitle-3 text-primary-darker mbs-0">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-gender' | exp:'':'Sexo' }}
                                </span>
                                <div class="flex-row flex-100 ">
                                    <!-- formControlName="gender" -->
                                    <mat-radio-group class="subtitle-3 text-primary-darker flex-row flex-50 ml-0 align-start"
                                        [name]="this.PATIENT_GENDER">
                                        <mat-radio-button [value]="'M'" >{{ 'modules.admissions.patient-data.patient-selector.male' | exp:'':'Hombre' }}</mat-radio-button>
                                        <mat-radio-button [value]="'F'" class="ml-3" >{{ 'modules.admissions.patient-data.patient-selector.female' | exp:'':'Mujer' }}</mat-radio-button>
                                        <mat-radio-button [value]="'S/E'" class="flex-100 ml-3" style="width: max-content !important;">{{ 'modules.admissions.patient-data.patient-selector.not-specified' | exp:'':'No especificado' }}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <form [formGroup]="this.formAddress">
                    <div class="flex-column" [formGroup]="this.formAddress">
                        <span class="text-primary-darker-h3 mt-1 flex-100 mbs-3">
                            {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.title' | exp:'':'Dirección' }}
                        </span>
                        <div class="flex-row flex-100 mb-0">
                            <div class="flex-30">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.state' | exp:'':'Provincia' }} *
                                </span>
                                <app-select-searching-input
                                [name]="this.PATIENT_ADDRESS_STATE"
                                [nameSearching]="this.PATIENT_ADDRESS_STATE_SEARCHING"
                                [form]="getFormAddressGroup()"
                                [placeholderSearching]="('modules.admissions.patient-data.patient-selector.patient-address-form.placeholders.searching-state' | exp:'':'Buscar provincia...')"
                                [calculateName]="this.calculateNameProvince"
                                [calculateId]="this.calculateIdProvince"
                                (selected)="this.selectProvince($event); resetAddressFields()"
                                [elements]="this.provincesOnSelect"
                                                                [defaultValue]="this.actualPatientProvince?.id ?? ''"
                                                                [forceNumber]="'true'">
                              </app-select-searching-input>
                            </div>
                            <div class="flex-40 ml-3">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.location' | exp:'':'Localidad' }} *
                                </span>
                                <app-select-searching-input [name]="this.PATIENT_ADDRESS_LOCATION"
                                    [form]="getFormAddressGroup()" [nameSearching]="this.PATIENT_ADDRESS_LOCATION_SEARCHING"
                                    [placeholderSearching]="('modules.admissions.patient-data.patient-selector.patient-address-form.placeholders.searching-location' | exp:'':'Buscar localidad...')"
                                    [calculateName]="this.calculateNameLocation"
                                    [calculateId]="this.calculateIdLocation"
                                    [defaultValue]="this.actualPatientLocation?.id ?? ''"
                                    [forceNumber]="'true'"
                                    [elements]="this.locations" (selected)="this.selectLocation($event); this.resetAddressFields(this.PATIENT_ADDRESS_LOCATION);
                                    ">
                                </app-select-searching-input>
                            </div>
                            <div class="flex-19 ml-3">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.zip-code' | exp:'':'Código postal' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_ADDRESS_ZIPCODE" [readonly]="true"
                                    [form]="getFormAddressGroup()">
                                </app-text-input>
                            </div>
                        </div>

                        <div class="flex-row flex-100 mb-0">
                            <div class="flex-60">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.street' | exp:'':'Calle y Nº' }}
                                </span>
                                <app-address-input
                                [name]="this.PATIENT_ADDRESS_STREET"
                                [address]="locationToInputAddress"
                                [city]="this.selectedCity"
                                [province]="this.selectedProvince"
                                [form]="getFormAddressGroup()"
                                (selected) = "onSelectAddress($event)"
                                (addressWithoutNumber)="onConfirmWithoutAddress($event)"
                                [getCheckState]="patientSelected?.address?.withoutNumber" >
                                </app-address-input>
                            </div>
                            <div class="flex-14 ml-3">

                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.floor' | exp:'':'Piso' }}
                                    </span>
                                    <app-text-input [name]="this.PATIENT_ADDRESS_FLOOR" [form]="getFormAddressGroup()" [numericOnly]="true"
                                        [hint]="'common.hints.solo-valores-numericos' | exp:'':'Solo números'">
                                    </app-text-input>

                            </div>
                            <div class="flex-14 ml-3">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.flat' | exp:'':'Departamento' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_ADDRESS_FLAT" [form]="getFormAddressGroup()">
                                </app-text-input>
                            </div>
                        </div>
                        <div class="flex-row flex-100 mt-0">
                            <div class="flex-52">
                                <span class="subtitle-3 text-primary-darker mbs-1">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-address-form.flat-extra' | exp:'':'Observaciones de la dirección' }}
                                </span>
                                <app-text-input [name]="this.PATIENT_ADDRESS_FLATEXTRA" [form]="getFormAddressGroup()">
                                </app-text-input>
                            </div>
                        </div>
                    </div>
                </form>
                <form [formGroup]="this.formContacts">
                    <div formArrayName="contacts">
                        <div *ngFor="let contact of contacts.controls; let i = index">
                            <div [formGroupName]="i" class="flex-column">
                                <span class="text-primary-darker-h3 mt-1 flex-100 mbs-3">
                                    {{ 'modules.admissions.patient-data.patient-selector.patient-contacts-form.title' | exp:'':'Datos de contacto' }} <span *ngIf="i !== 0">{{ i + 1 }}</span>
                                    <button mat-icon-button [matTooltip]="('common.delete-variant' | exp:'':'Eliminar')" color="primary" class="mt-2"
                                        (click)="removeContact(i)" *ngIf="contacts.length > 1 || i !== 0">
                                        <mat-icon>delete_outlined</mat-icon>
                                    </button>
                                </span>

                                <div class="flex-row flex-wrap flex-100">
                                    <div class="flex-column flex-45 mr-3" >
                                        <span class="subtitle-3 text-primary-darker mbs-1">{{ 'modules.admissions.patient-data.patient-selector.patient-contacts-form.phone-number' | exp:'':'Teléfono' }}</span>
                                        <app-text-input [name]="this.PATIENT_NEW_CONTACT_PHONE"
                                            [form]="getContactFormGroup(i)">
                                        </app-text-input>
                                    </div>
                                    <div class="flex-column flex-45">
                                        <span class="subtitle-3 text-primary-darker mbs-1">{{ 'modules.admissions.patient-data.patient-selector.patient-contacts-form.email' | exp:'':'Email' }}</span>
                                        <app-email-input [name]="this.PATIENT_NEW_CONTACT_EMAIL"
                                            [form]="getContactFormGroup(i)" >
                                        </app-email-input>
                                    </div>
                                </div>
                                    <div class="flex-row flex-100 align-start-center mt-0 mbs-0">
                                        <div class="flex-column">  <!-- flex-65 -->
                                            <span class="subtitle-3 text-primary-darker mbs-1">{{ 'modules.admissions.patient-data.patient-selector.patient-contacts-form.reference' | exp:'':'Referencia' }}
                                            </span>
                                            <app-text-area-input [name]="this.PATIENT_NEW_CONTACT_REFERENCE" [form]="getContactFormGroup(i)"> </app-text-area-input>
                                        </div>
                                        <mat-radio-group formControlName="isMainContact" name="isMainContact" (change)="changeMainContact()" class="align-space-between"
                                            *ngIf="contacts.length > 1" [disabled]="contacts.length <= 1">
                                            <mat-radio-button class="subtitle-3 text-primary-darker"
                                                [value]="true">{{ 'modules.admissions.patient-data.patient-selector.patient-contacts-form.main-contact' | exp:'':'Contacto principal' }}</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>

                </form>
                <div class="flex-row flex-100 mt-2 mr-3 align-space-between-center full-width">
                    <button mat-stroked-button [color]="'accent'" btn
                        [disabled]="btn_addContact_disabled || this.isloadingUpdate" id="Admission_editPatient"
                        class="btnStyle" [matTooltip]="('modules.admissions.patient-data.patient-selector.add-new-contact-button' | exp:'':'Agregar nuevo contacto') " (click)="this.addContact()">
                        {{ ('modules.admissions.patient-data.patient-selector.add-new-contact-button' | exp:'':'Agregar Nuevo Contacto')  }}
                    </button>
                    <div *ngIf="this.isPatientInputParam" class="flex-row align-space-around-center gap-1-5em">
                        <button mat-stroked-button [color]="'primary'" (click)="clickCancelEditPatient()"
                            [disabled]="this.isloadingUpdate">
                            <span>{{ ('common.cancel' | exp:'':'Cancelar')  }}</span>
                        </button>
                        <button mat-flat-button [color]="'primary'"
                            [disabled]="!this.formPatienValid || this.caseActive != null || !patientWithoutNumberCheck && patientWithoutStreetNumber"
                            (click)="clickConfirmEditPatient()">
                            <span *ngIf="!this.isloadingUpdate; else loadingConfirmIcon">
                                {{ ('common.confirm' | exp:'':'Confirmar')  }}
                            </span>
                            <ng-template #loadingConfirmIcon>
                                <mat-icon>
                                    <mat-spinner color="accent" diameter="20">
                                    </mat-spinner>
                                </mat-icon>
                            </ng-template>
                        </button>
                    </div>
                </div>
            </div>
        </app-theme-card>
    </div>
</div>

<ng-template #patientCaseActive>
    <div class="flex-column flex-100">
        <div class="flex-column bg-primary-lighter p-5">
            <div class="flex-row align-center">
                <mat-icon svgIcon="WarningCircle" style="height: 55px; width: 55px;"></mat-icon>
            </div>
            <span class="subtitle-3 active-case-text-margin" style="text-align: center;">
                El {{('modules.admissions.patient-data.patient-selector.patient-case-active.patient-word' | exp:'':'paciente') | lowercase}} {{this.patientSelected?.surname + ", " + this.patientSelected?.name }} ya tiene
                {{this.isRequisition(this.caseActive != null ? this.caseActive : this.closedCase) ? ('modules.admissions.patient-data.patient-selector.patient-case-active.requisition-article' | exp:'':'una') : ('modules.admissions.patient-data.patient-selector.patient-case-active.case-article' | exp:'':'un')}}
                    {{this.isRequisition(this.caseActive != null ? this.caseActive :
                    this.closedCase) ? ('modules.admissions.patient-data.patient-selector.patient-case-active.requisition-label' | exp:'':'solicitud') : ('modules.admissions.patient-data.patient-selector.patient-case-active.case-label' | exp:'':'caso')}} {{this.closedCase != null ? ('modules.admissions.patient-data.patient-selector.patient-case-active.closed-status' | exp:'':'cerrado') : ('modules.admissions.patient-data.patient-selector.patient-case-active.in-management-status' | exp:'':'en gestión')}}.
            </span>
        </div>
        <div class="flex-column m-5 border-data">
            <span class="content-margin">{{ 'modules.admissions.patient-data.patient-selector.case-id-prefix' | exp:'':'ID #' }}</span>
            <div class="flex-row content-margin">
                <app-text-input [form]="this.formPatientCaseActive" [name]="this.PATIENT_NAME_CASE_ACTIVE"
                    class="flex-100">
                </app-text-input>
            </div>
            <button mat-stroked-button class="text-primary content-margin-right subtitle-3 btnVerCaso"
                [color]="'primary'" (click)="redirectToCase()">
                {{this.isRequisition(this.caseActive != null ? this.caseActive : this.closedCase) ? ('modules.admissions.patient-data.patient-selector.open-requisition' | exp:'':'Ver solicitud') :
                ('modules.admissions.patient-data.patient-selector.open-case' | exp:'':'Ver caso') }}
            </button>
            <span class="content-margin mt-4">{{ 'modules.admissions.patient-data.patient-selector.operator' | exp:'':'Operador' }}</span>
            <div class="content-margin align-start">
                <app-text-input [form]="this.formPatientCaseActive" [name]="this.PATIENT_OPERATOR_CASE_ACTIVE"
                    class="flex-100"></app-text-input>
            </div>
            <div class="flex-row align-space-around-center mt-3">
                <button mat-raised-button [color]="'primary'"
                    (click)="this.parentComponent == 'admission-creation' ? this.returnToDashboard() : this.closeDialog()">
                    {{(this.closedCase != null ? ('common.cancel' | exp:'':'Cancelar') : ('common.ok' | exp:'':'Ok'))  }}
                </button>
                <button mat-raised-button *ngIf="this.parentComponent == 'admission-creation'" [color]="'primary'"
                    (click)="this.addTask()">
                    {{ ('modules.admissions.patient-data.patient-selector.add-task-button' | exp:'':'Generar Tarea')  }}
                </button>
                <button mat-raised-button *ngIf="this.closedCase != null" [color]="'primary'"
                    (click)="this.confirmChanges()">{{ ('modules.admissions.patient-data.patient-selector.confirm-change-button' | exp:'':'Confirmar Cambios')  }}</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #selectTask>
    <div class="flex-column align-center-center">

        <form [formGroup]="formSelectTask">
            <mat-radio-group class="flex-column align-start none gap-1em " formControlName="radioButton"
                (change)="this.radioButtonSelected( $event )">
                <mat-radio-button [value]="RequisitionTypes.PROVISIONAL_INCREMENT"><span class="text-primary-darker">
                    {{ 'modules.admissions.patient-data.patient-selector.select-task-form.options.provisional-increment' | exp:'':'Aumento prestacional' }}</span></mat-radio-button>
                <mat-radio-button [value]="RequisitionTypes.AUTHORIZATION"><span class="text-primary-darker">
                    {{ 'modules.admissions.patient-data.patient-selector.select-task-form.options.authorization' | exp:'':'Autorización' }}</span></mat-radio-button>
                <ng-container *tenantFeature="'admissions.updateCircuit'">
                <mat-radio-button [value]="RequisitionTypes.PARTIAL_DISCHARGE"><span class="text-primary-darker">
                        {{ 'modules.admissions.patient-data.patient-selector.select-task-form.options.partial-discharge' | exp:'':'Baja parcial' }}</span></mat-radio-button>
                <mat-radio-button [value]="RequisitionTypes.ENDING"><span class="text-primary-darker">
                        {{ 'modules.admissions.patient-data.patient-selector.select-task-form.options.ending' | exp:'':'Finalización' }}</span></mat-radio-button>
                </ng-container>
            </mat-radio-group>
        </form>

        <div class="mt-6"></div>

        <div class="flex-row align-space-around center gap-2em">
            <button mat-stroked-button [color]="'primary'" (click)="returnToDashboard()" [disabled]="">
                <span>{{ ('common.cancel' | exp:'':'Cancelar')  }}</span>
            </button>
            <button mat-flat-button [color]="'primary'" [disabled]="!formSelectTask.valid"
                (click)="clickConfirmSelectTask()">
                <span>
                    {{ ('common.save' | exp:'':'Guardar')  }}
                </span>
            </button>
        </div>
    </div>
</ng-template>
